import store from '../store';
import {message} from 'ant-design-vue'
// import moment from 'moment';
import jscookie from "js-cookie";
import MD5 from "md5.js";

export const GLOBAL = {

    flushRightContent() {
        store.commit("save", {routerKey: Math.random()})
    },

    p(obj, type = 'log') {
        let log = JSON.parse(JSON.stringify(obj));
        console[type](log)
    },

    //显示提示信息
    //type对应的值有success error warning
    showMsg({type = 'error', msg = ''}) {
        message[type](msg)
        if (type == 'error') {
            throw new Error(msg)
        }
    },

    //获取当前url中的参数值  返回值为 object对象
    UrlQueryString(uri = window.location.href) {
        window.urlparams = {};
        //如果是hash方式的url 替换掉#
        if (/\/(.*)?#\//.test(uri)) {
            uri = uri.replace('/#', ''); //匹配  /#/ 的情况
            uri = uri.replace('#/', '/'); //匹配  /xxx.[html|htm|xxxx]#/ 的情况   两种连续替换不冲突
        }
        // console.log('replace:',uri)
        const url = require('url');
        window.urlparams = url.parse(uri, true).query; //写成true 返回 object对象, 否则为string 如 s=aa&id=123
        return window.urlparams;
    },

    //获取表单数据 instance 相当于 vue页面中的this
    getFormValues({instance, format = "YYYY/MM/DD"}) {
        let values = instance.form.getFieldsValue() || {}
        if (values.rangtime) {
            values["starttime"] = values.rangtime[0].format(format)
            values["endtime"] = values.rangtime[1].format(format)
        }
        return values
    },

    /**
     * 字符串md5加密
     * @param {String} str
     */
    md5(str) {
        return new MD5().update(str.toString()).digest("hex")
    },

    /**
     * 随机生成一个md5字符串
     */
    randMD5() {
        return this.md5(Math.random())
    },

    /**
     * 检测用户是否已经登录
     */
    checkAccessAble(topath) {
        let fk_id = jscookie.get("fk_id");
        if (!fk_id) {
            store.commit("save", {isLogin: false})
            return 0

        } else {
            store.commit("save", {isLogin: true})
            //判断路由
            let cUser = this.getCurrentUser();
            if (!cUser) {
                store.commit("save", {isLogin: false})
                return 0
            }
            if (cUser.menus.indexOf(topath) != -1) {
                //登录已授权
                return 1
            } else if (cUser.menus.indexOf('all') == 0) {
                return 1
            } else {
                //登录未授权
                return 1
            }

        }
    },

    /**
     * 刷新用户所属系统的appcode相关数据
     */
    updateAuthedAppcodes(that, uid) {
        let c_params = {
            urlparams: false,
        }
        that.$store.dispatch({
            type: "logservice/queryauthedappcodes",
            params: c_params,
            showMsg: false
        }).then((res) => {
            if (res.data.success == 1) {
                let applist = res.data.data;
                let userAppcodes = {};
                userAppcodes.uid = uid;
                userAppcodes.applist = applist;
                localStorage.setItem("authedAppcodes", JSON.stringify(userAppcodes));
            } else {
                that.message.error('获取已授权appcodes失败')
            }
        })
    },

    getServiceConsumApps(appcode,starttime,endtime,that,servicekey){
        let whereStr = '';
        if(servicekey){
            whereStr = " and url ='" + servicekey + "'"
        }
        let params = {
            projectname: that.G.getServiceMonitorName(),
            logstorename:'service-monitor',
            starttime:(new Date(starttime).getTime())/1000,
            endtime:(new Date(endtime).getTime())/1000,
            sql:"* | select distinct(invokeappcode) from log where appcode = '" + appcode +"'" + whereStr,
            reverse:false,
            pageSize:100,
            offset:0,
            paged:false,
            timeout:15000,
            urlparams:false
        };
        that.$store.dispatch({
            type: "logservice/querylog",
            params:params
        }).then((res)=>{
            if(res.status == 200 && res.data.success == '1'){
                let result = res.data.data;
                if(result.list.length > 0){
                    let tempL = []
                    result.list.forEach(element => {
                        tempL.push(element.invokeappcode)
                    });
                    that.invokappcodes = tempL
                }
                else{
                    that.invokappcodes = []
                }
            }
        }).catch(() => {

        });
    },

    getAllAppcodes(that){
        let c_params = {
            isAll:'1',
            urlparams: false,
        }
        let res = that.D.syncSelect({
            type: "logservice/queryauthedappcodes",
            params: c_params,
            showMsg: false
        });
        if (res.success == 1) {
            let resultAppcodes = [];
            let result = res.data;
            result.forEach(element => {
                resultAppcodes.push(element.appcode)
            });
            return resultAppcodes
        } else {
            return [];
        }
    },

    getAuthedAppcodes(that) {
        let c_user = this.getCurrentUser(that);
        let c_authedAppcodes = localStorage.getItem('authedAppcodes');
        if (c_authedAppcodes) {
            c_authedAppcodes = JSON.parse(c_authedAppcodes)
        } else {
            this.updateAuthedAppcodes(that, c_user.uid)
            c_authedAppcodes = {};
        }
        if (c_user.uid == c_authedAppcodes.uid) {
            let resultAppcodes = [];
            for (let index = 0; index < c_authedAppcodes.applist.length; index++) {
                const element = c_authedAppcodes.applist[index];
                resultAppcodes.push(element.appcode)
            }

            return resultAppcodes
        } else {
            this.updateAuthedAppcodes(that, c_user.uid)
            that.message.info("获取已授权appcodes失败，请重试");
            return []
        }
    },

    clearMonitorCach() {
        let cachNames = [
            'monitorErrorSumData',
            'currentSystemMsg',
            'monitorErrorSumData',
            'monitorserviceSearch',
            'monitorserviceFlowService',
            'monitorserviceDetailSearch',
        ]
        cachNames.forEach(element => {
            localStorage.setItem(element, '')
        });
    },

    /**
     * 获取当前登录用户信息
     */
    getCurrentUser(instance) {
        try {
            let temp_user = localStorage.getItem('userInfo');
            if (temp_user) {
                return JSON.parse(temp_user)
            } else {
                this.logout(instance)
            }
        } catch (e) {
            if (instance) {
                //登出
                this.logout(instance)
            }
        }
    },
    isUserAdmin() {
        try {
            let temp_user = localStorage.getItem('userInfo');
            if (temp_user) {
                let c_user = JSON.parse(temp_user)
                return c_user.identitykey == "13000000000" || c_user.identitykey == "13813924364"
            } else {
                return false
            }
        } catch (e) {
            return false
        }
    },

    /**
     * 退出登录
     */
    logout(instance) {
        if (instance) {
            instance.$store.dispatch({
                type: "home/loginout",
                params: {urlparams: false}
            }).then(() => {
                this.clearUserInfo(instance)
            }).catch(() => {
                this.clearUserInfo(instance)
            })
        } else {
            this.clearUserInfo(instance)
        }

    },
    clearUserInfo(instance) {
        store.commit("save", {isLogin: false})
        jscookie.remove("fk_id");
        localStorage.setItem('userInfo', '')
        instance.$router.push({
            path: '/login',
            query: {
                redirect: instance.$route.fullPath
            }
        })
    },
    formatTimesapn(t) {
        let c_date = new Date(parseInt(t * 1000));
        let fmt = "yyyy/MM/dd hh:mm:ss";
        let o = {
            'M+': c_date.getMonth() + 1, //月份
            'd+': c_date.getDate(), //日
            'h+': c_date.getHours(), //小时
            'm+': c_date.getMinutes(), //分
            's+': c_date.getSeconds(), //秒
            'q+': Math.floor((c_date.getMonth() + 3) / 3), //季度
            'S': c_date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (c_date.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (let k in o)
            if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        return fmt;
    },
    getRecentDate(rangeType) {
        var start_time = '';
        var end_time = '';
        var now = new Date();
        var nowTime = now.getTime();
        var day = now.getDay();
        if (day == 0) {
            day = 7;
        }
        var oneDayLong = 24 * 60 * 60 * 1000;
        var oneMinitLong = 60 * 1000;
        var MondayTime = nowTime - (day - 1) * oneDayLong;
        var SundayTime = nowTime + (8 - day) * oneDayLong;
        var monday = new Date(MondayTime);
        var sunday = new Date(SundayTime);
        let title = ""


        var nowMonth = now.getMonth(); //当前月
        var nowYear = now.getYear(); //当前年
        nowYear += (nowYear < 2000) ? 1900 : 0; //
        var lastMonthDate = new Date(); //上月日期
        lastMonthDate.setDate(1);
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
        var lastMonth = lastMonthDate.getMonth();


        //获得某月的天数
        function getMonthDays(myMonth) {
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        function getDay(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = doHandleMonth(tMonth + 1);
            tDate = doHandleMonth(tDate);
            return tYear + '-' + tMonth + '-' + tDate;
        }

        function doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = '0' + month;
            }
            return m;
        }

        //今天
        if (rangeType == '1') {
            start_time = getDay(0) + ' 00:00:00';
            end_time = getDay(1) + ' 00:00:00';
            title = "今天"
        }
        //昨天
        if (rangeType == '2') {
            start_time = getDay(-1) + ' 00:00:00';
            end_time = getDay(0) + ' 00:00:00';
            title = "昨天"

        }
        //本周
        if (rangeType == '3') {
            start_time = monday.Format('yyyy/MM/dd') + ' 00:00:00';
            end_time = sunday.Format('yyyy/MM/dd') + ' 00:00:00';
            title = "本周"

        }
        //上周
        if (rangeType == '4') {
            MondayTime = MondayTime - 7 * oneDayLong;
            SundayTime = SundayTime - 7 * oneDayLong;
            monday = new Date(MondayTime);
            sunday = new Date(SundayTime);
            start_time = monday.Format('yyyy/MM/dd') + ' 00:00:00';
            end_time = sunday.Format('yyyy/MM/dd') + ' 00:00:00';
            title = "上周"

        }
        //本月
        if (rangeType == '5') {
            var monthStartDate = new Date(nowYear, nowMonth, 1);
            var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
            start_time = monthStartDate.Format('yyyy/MM/dd') + ' 00:00:00';
            end_time = monthEndDate.Format('yyyy/MM/dd') + ' 23:59:59';
            title = "本月"

        }
        //上月
        if (rangeType == '6') {
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            start_time = lastMonthStartDate.Format('yyyy/MM/dd') + ' 00:00:00';
            end_time = lastMonthEndDate.Format('yyyy/MM/dd') + ' 23:59:59';
            title = "上月"
        }

        //1分钟
        if (rangeType == '7') {
            start_time = new Date(nowTime - oneMinitLong * 1).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "1分钟"
        }

        //5分钟
        if (rangeType == '8') {
            start_time = new Date(nowTime - oneMinitLong * 5).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "5分钟"
        }
        //1小时
        if (rangeType == '9') {
            start_time = new Date(nowTime - oneMinitLong * 60).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "1小时"
        }

        //15分钟
        if (rangeType == '10') {
            start_time = new Date(nowTime - oneMinitLong * 15).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "15分钟"
        }

        //1天
        if (rangeType == '11') {
            start_time = new Date(nowTime - oneMinitLong * 60 * 24).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "1天"
        }

        //2天
        if (rangeType == '13') {
            start_time = new Date(nowTime - oneMinitLong * 60 * 24 * 2).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "3天"
        }

        //3天
        if (rangeType == '12') {
            start_time = new Date(nowTime - oneMinitLong * 60 * 24 * 3).Format("yyyy/MM/dd hh:mm:ss");
            end_time = now.Format('yyyy/MM/dd hh:mm:ss')
            title = "3天"
        }

        let result = {
            start_time: start_time,
            end_time: end_time,
            title: title
        }
        // console.log(result)

        return result;


    },
    generateUUID() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },

    //产生随机数函数
    RndNum(n){
        var rnd="";
        for(var i=0;i<n;i++)
            rnd+=Math.floor(Math.random()*10);
        return rnd;
    },
    
    //echarts 配色方案
    getChartColors(){
        return [
            '#63b2ee',
            '#76da91',
            '#f8cb7f',
            '#f89588',
            '#7cd6cf',
            '#9192ab',
            '#7898e1',
            '#efa666',
            '#eddd86',
            '#9987ce',
            '#63b2ee',
            '#76da91',
        ]
    },

    parseString(str){
        let targetStr = str.split("'");
        if(targetStr.length > 1){
            targetStr = targetStr[1]
        }
        else{
            targetStr = targetStr[0]
        }
        return targetStr;
    },

    getServiceMonitorName(){
        return (window.location.host == "f.cnzhonglunnet.com" || window.location.host == "fp.cnzhonglunnet.com" || window.location.host == "fp.cnzhonglunnet.com") ? "service-monitor" : "test-service-monitor"
    },
    /**
     * @description: 随机生成uuid
     */
    getUniqueCode() {
        const s = [];
        const hexDigits = "0123456789abcdef";

        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }

        s[14] = "4";
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = "-";

        return s.join("");
    },

    /**
     * @description: 获取文件后缀
     * @param {string} filename
     */
    getSuffix(filename) {
        const pos = filename.lastIndexOf('.');
        let suffix = '';

        if (pos !== -1) {
            suffix = filename.substring(pos);
        }

        return suffix;
    },

}
